import React, { useState, Fragment } from 'react';
import SalesPeriodUnit from './SalesPeriodUnit';

import { getRenderPeriodData } from '../../../app/Helper/PeriodHelper';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

/**
 * 판매기간 계산
 */
function getDate(now, end) {
  const remain = end - now;
  const day = Math.floor(remain / DAY);
  const hour = Math.floor((remain % DAY) / HOUR);
  const minutes = Math.floor((remain % HOUR) / MINUTE);
  const seconds = Math.floor((remain % MINUTE) / SECOND);

  return {
    day,
    hour,
    minutes,
    seconds,
  };
}

/**
 * 판매기간 컴포넌트
 */
function SalesPeriod() {
  const { type, data } = getRenderPeriodData();
  const { isPermanentSales, endDate } = data;
  const [now, setNow] = useState(new Date().getTime());
  const end = endDate && new Date(endDate.replace(/-/g, '/')).getTime();
  const { day, hour, minutes, seconds } = getDate(now, end);
  const isRender =
    type === 'normal' &&
    !(isPermanentSales || !endDate) &&
    now < end &&
    day < 7;

  return (
    <Fragment>
      {isRender && (
        <SalesPeriodUnit
          day={day}
          hour={hour}
          minutes={minutes}
          seconds={seconds}
          setNow={setNow}
        />
      )}
    </Fragment>
  );
}

export default SalesPeriod;
